export default {"src":"/_next/static/media/courses-3.de099365.svg","height":96,"width":242,"blurWidth":0,"blurHeight":0};